import { render, staticRenderFns } from "./cms-block-cms-list.vue?vue&type=template&id=6ad18a24&scoped=true"
import script from "./cms-block-cms-list.vue?vue&type=script&lang=js"
export * from "./cms-block-cms-list.vue?vue&type=script&lang=js"
import style0 from "./cms-block-cms-list.vue?vue&type=style&index=0&id=6ad18a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad18a24",
  null
  
)

export default component.exports